const snakecaseKeys = require('snakecase-keys');

const snake = val => {
    // @TMP HOTFIX TO HANDLE FORMDATA.
    if (typeof val !== 'object' || val instanceof FormData) {
        return val;
    }
    const regexpToIgnoreDots = /\./;
    return snakecaseKeys(val, { deep: true, exclude: [regexpToIgnoreDots] });
};

export default val => snake(val);
